import { computed, Ref, unref } from 'vue';
import { skipToken, useQuery } from '@tanstack/vue-query';
import { fetchComplianceSummary } from './report.endpoints';
import { TComplianceSummaryPayload } from '../models/types';

export function useFetchComplianceSummary(payloadRef: Ref<TComplianceSummaryPayload | null>) {
  return useQuery({
    queryKey: computed(() => {
      const payload = unref(payloadRef);
      return [
        'complianceSummary',
        payload?.jobId,
        payload?.integrationId,
        payload?.folderName ?? null,
      ];
    }),
    queryFn: computed(() => {
      const payload = unref(payloadRef);
      if (!payload) return skipToken;
      return () => fetchComplianceSummary(payload);
    }),
  });
}
